export default __webpack_public_path__ + "static/media/senti.456ed9fd.ico";